const FAILURE_STATUSES = new Set(["FAILED", "ERROR", "CANCELLED"]);

function getPayloadString(
  payload: Record<string, unknown> | undefined,
  keys: string[],
): string | null {
  if (!payload) return null;

  for (const key of keys) {
    const value = payload[key];
    if (typeof value === "string" && value.trim().length > 0) {
      return value.trim();
    }
  }

  return null;
}

export function isFailureSyncStatus(
  status: string | null | undefined,
): boolean {
  return (
    typeof status === "string" && FAILURE_STATUSES.has(status.toUpperCase())
  );
}

export function deriveSyncFailureMessage(params: {
  status?: string | null;
  payload?: Record<string, unknown>;
  fallback?: string;
}): string {
  const fromPayload = getPayloadString(params.payload, [
    "error",
    "technicalMessage",
    "technical_message",
    "userMessage",
    "user_message",
    "message",
  ]);
  if (fromPayload) return fromPayload;

  const status = params.status?.toUpperCase();
  if (status === "CANCELLED") {
    return "The sync was cancelled before it finished. You can retry the sync when ready.";
  }

  return (
    params.fallback ??
    "The sync stopped before it could finish. Review the log and retry the sync."
  );
}
